/*
 * @Author: JamesWong
 * @Description: 首页中文
 * @Date: 2018-11-29 10:34:46
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-13 13:12:41
 */

export default {
  productName: '犀牛EPOS企业管理后台',
  companyNo: '企业编号',
  companyEnterTips: '请输入企业编号',
  account: '登陆账号',
  accountEnterTips: '请输入登陆账号',
  password: '输入密码',
  passwordEnterTips: '请输入密码',
  login: '登陆',
  Logout: '退出',
  backHome: '返回首页',
  openedService: '已开通的服务',
  sellModel: '收银模块',
  foundational: '基础物流',
  appVersion: '应用版本',
  authChannel: '授权店铺',
  allAuthChannel: '总授权店铺数',
  authWarehouse: '授权仓库',
  authMumber: '已授权数',
  remainAuthNum: '剩余可授权数',
  whalesaleSelected: '批发零售版选用',
  deviceActivateManagement: '激活码管理',
  subScreen: '副屏交互设置',
  displayMode: '显示模式',
  rollingDisplay: '轮播图片',
  advertisementVideo: '广告视频',
  ticketDisposition: '小票配置',
  selfcashierDisposition: '自收银配置',
  onlinePayDisposition: '线上支付配置',
  accountModule: '账户',
  collaboraivePlatformSet: '协同平台设置',
  foundationalSet: '物流模块配置',
  depositReceipt: '定金单配置',
  loginNumTips: '企业编号不能为空！',
  '剩余天数': '，剩余天数',
  loginAccountTips: '登录账号不能为空！',
  alipayCall: '完成授权，请回到犀牛EPOS管理后台查看授权结果',
  noSet: '未配置, 物流功能不能正常使用',
  authorizedMessage: '授权信息',
  storeAuthorizaedManage: '店铺授权管理',
  manageAllFacility: '设备归属管理',
  record: '门店登录记录',
  '收银模块': '收银模块',
  '物流模块': '物流模块',
  '其他': '其他',
  changeLog: '设备变更记录',
  'deviceChangeLog': '设备变更记录',
  'deviceUntiedLog': '设备解绑记录',
  'Web端使用ERP物流模块': 'Web端使用ERP物流模块',
  styleTicketManager: '单据打印样式管理',
  onlineMonitoring: '设备在线监管'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/main.js